<template>
  <sc-page-base :title="title"
                :box="true"
                :loading="loading">
    <div class="columns">

      <section class="column sc-files">

        <button @click="loadInvoices()"
                class="button is-primary sc-files__refresh">Atualizar lista</button>

        <div class="box">
          <sc-tabs
            type="is-boxed"
            v-model="activeTab"
            :animated="false"
            @input="loadInvoices()"
            class="sc-files__tab-group">
            <sc-tab-item v-for="(fileType, index) in fileTypes"
                         :key="index"
                         :label="fileType.label"
                         class="sc-files__tab-item">
            </sc-tab-item>
          </sc-tabs>

          <sc-table
            :data="reports"
            :bordered="true"
            :paginated="reports.length > perPage"
            :per-page="perPage"
            default-sort="first_name"
            class="sc-files__table">

            <template slot-scope="props">
              <sc-table-column
                field="filename"
                label="Arquivo"
                sortable>
                {{ props.row.display_name }}
              </sc-table-column>

              <sc-table-column
                field="status"
                label="Status"
                sortable>
                {{ props.row.status }}
              </sc-table-column>

              <sc-table-column
                field="created"
                label="Criado em"
                sortable>
                {{ props.row.created | date('DD/MM/YYYY - HH:mm') }}
              </sc-table-column>

              <sc-table-column>
                <button
                  class="button is-primary"
                  @click="download(props.row)">
                  Download
                </button>
              </sc-table-column>
            </template>

            <template slot="empty">
              <sc-table-empty />
            </template>
          </sc-table>

        </div>

      </section>
    </div>
  </sc-page-base>
</template>

<script>
  import {
    ScPageBase,
    ScTabs,
    ScTabItem,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapActions } = createNamespacedHelpers('recon/preInvoiceGenerationFiles');

  export default {
    name: 'page-files-pre-invoice-generation',
    data() {
      return {
        title: 'Meus arquivos - Pré-fatura',
        activeTab: 0,
        currentPage: 1,
        perPage: 20,
        fileTypes: [
          { label: 'Todos', type: '' },
        ],
      };
    },
    computed: {
      ...mapState([
        'loading',
        'reports',
      ]),
    },
    methods: {
      ...mapActions([
        'getReportList',
        'download',
      ]),
      loadInvoices() {
        const { type = '' } = this.fileTypes[this.activeTab];

        this.getReportList(type);
      },
    },
    beforeMount() {
      const { type = '' } = this.$route.params;

      this.activeTab = this.fileTypes.findIndex(fileType => fileType.type === type);
      this.loadInvoices();
    },
    components: {
      ScPageBase,
      ScTabs,
      ScTabItem,
      ScTable,
      ScTableColumn,
      ScTableEmpty,
    },
  };
</script>
<style lang="scss" scoped>
  .sc-files {
    &__refresh {
      margin-bottom: 2rem;
    }
     &__table {
      margin-left: -1rem;
      margin-right: -1rem;
       td {
        vertical-align: inherit;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/files/pre-invoice-generation/PageFilesPreInvoiceGeneration.vue